<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout mt-4 wrap mr-2>
      <v-flex xs12>
        <v-combobox
          v-model="assignedCustomers"
          :items="customers"
          label="Assign customers"
          item-value="_id"
          item-text="name"
          multiple
          outlined
          dense
          chips
        >
        </v-combobox>
      </v-flex>
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn @click="$emit('save', assignedCustomers)" color="error"
          >Save</v-btn
        >
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import request from "@/modules/request";
import ActionModal from "./ActionModal";

export default {
  name: "AssignCustomerModal",
  props: {
    title: {
      type: String,
      default: "",
    },
    customers: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      assignedCustomers: [],
    };
  },
  components: {
    ActionModal,
  },
  methods: {
    close() {
      this.$emit("update:assignCustomerModal", false);
    },
  },
};
</script>
